import React from 'react';
import {RegisterOptions} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import InputText, {IInputTextProps} from './InputText';

interface InputNameProps extends IInputTextProps {
    onClick?: () => void;
}

const InputName: React.FC<InputNameProps> = ({onClick, ...props}) => {

    const NAME_PATTERN = /^.{2,}$/; 

    const rules: RegisterOptions = {
        pattern: {value: NAME_PATTERN, message: t`Некорректное значение`},
        required: t`Не указано значение`,
    };

    return (
        <InputText
            rules={rules}
            onClick={onClick}
            {...props}
        />
    );
};

export default InputName;